export default __webpack_public_path__ + "static/mdx-f71f535c1664e183c88a2f48fc9217bb.png";